// TODO: IDs to be changed to match the actual app IDs once finalized. These are just placeholders for now.
// Note: IDs may differ between DEV and PROD environments
export const APP_IDS = {
  HOME: 'home',
  // Trane Cloud
  CLOUD: '44b78402-facf-4b93-8439-93262f36fc72',
  MARKETPLACE: 'marketplace',
  BRAINBOX: 'brainbox',
  //Trane Maintenance Management
  TMM: '0b12c499-83ad-4ace-a3bb-98209dbd0911',
  // Command Center
  COMMAND_CENTER: '10e04b38-626a-479f-a152-2c0db0c16441',
  SETUP: 'setup',
  ACCOUNT_SETTINGS: 'account-settings',
  // Trane Connect
  CONNECT: '9b308188-33ad-4a84-8974-a412dc03e3f6',
} as const;

// Environment-based URL constants
// TODO: Update these URLs as needed for development and production environments
// Note: Empty strings for internal routes (HOME, TMM, SETUP, ACCOUNT_SETTINGS) should use SPA navigation
const DEV_URLS = {
  [APP_IDS.HOME]: '',
  [APP_IDS.CLOUD]: 'https://tranecloud.com/',
  [APP_IDS.MARKETPLACE]: process.env.REACT_APP_MARKETPLACE_URL || '',
  [APP_IDS.BRAINBOX]: '',
  [APP_IDS.TMM]: '/',
  [APP_IDS.COMMAND_CENTER]: 'https://tcc.tis.trane.com/',
  [APP_IDS.SETUP]: '',
  [APP_IDS.ACCOUNT_SETTINGS]: '',
  [APP_IDS.CONNECT]: 'https://dev.connect.tis.trane.com/',
} as const;

const PROD_URLS = {
  [APP_IDS.HOME]: '',
  [APP_IDS.CLOUD]: 'https://tranecloud.com/',
  [APP_IDS.MARKETPLACE]: process.env.REACT_APP_MARKETPLACE_URL || '',
  [APP_IDS.BRAINBOX]: '',
  [APP_IDS.TMM]: '/',
  [APP_IDS.COMMAND_CENTER]: 'https://tcc.tis.trane.com/',
  [APP_IDS.SETUP]: '',
  [APP_IDS.ACCOUNT_SETTINGS]: '',
  [APP_IDS.CONNECT]: 'https://connect.tis.trane.com/',
} as const;

// Use TIS_ENV to determine environment (DEV/PROD)
// NODE_ENV only indicates local dev vs production build, not deployment environment
const tisEnv = process.env.REACT_APP_TIS_ENV || 'development';
const isDev = tisEnv === 'development';

export const APP_URLS = isDev ? DEV_URLS : PROD_URLS;

// AppSync Configuration
// Use environment variables for flexibility across DEV and PROD
export const APPSYNC_URL =
  process.env.REACT_APP_TIS_GQL_URL ||
  'https://56exjy53zfey5bwvnr3q5qrh2a.appsync-api.us-east-1.amazonaws.com/graphql';
export const APPSYNC_REGION = process.env.REACT_APP_TIS_GQL_REGION || 'us-east-1';
